import { Card, Dialog, DialogContent, DialogTitle, Grid2, Typography } from "@mui/material";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { GridDeleteForeverIcon } from "@mui/x-data-grid";
import { AxiosResponse } from "axios";
import { getValoresDominio } from "../../../../services/servicesDominio";
import { Dominios, StatusCode } from "../../../../utils/enums";
import { selectorTransversal } from "../../../../dtos/selector";
import { useEffect, useState } from "react";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import { useForm } from "react-hook-form";
import { CoberturaPoliza, monedaOrigenDto, PolizaSeguro, UpdatePoliza } from "../models/polizaSeguro";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import ModalCobertura from "./modalCobertura";
import { getCoberturas, getDetallePoliza, getMonedas } from "../service/servicePoliza";
import Tabla from "../../../../components/ui/materialui/tabla";
import { Label } from "@mui/icons-material";
import { usePoliza } from "../hooks/usePoliza";
import { useToast } from "../../../../hooks/useToast";
import { useColumnsCobranza } from "../utils/columnsCobranza";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { set } from "date-fns";
import { getCompanias } from "../../../remesas/consultarRemesas/services/consultarRemesasServices";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";


interface CreateEditPolizaProps {
    codigoPoliza?: string;
    onVolver: () => void;
    polizaEditar?: UpdatePoliza | undefined;
    onHide?: () => void
    isEdit?: boolean;
    refresh?: () => void;

}
const schema = yup.object({
    codigo: yup
        .string()
        .required("El código es requerido")
        .min(1, "El código debe tener al menos 1 caracter")
        .max(10, "El código no puede exceder 10 caracteres")
        .matches(
            /^(?=.*[0-9])[A-Za-z0-9]+$/,
            "Ingrese un código válido"
        ),
    codigohijo: yup.string().required("El código hijo es requerido")
        .min(1, "El código hijo debe tener al menos 1 caracter").max(10, "El código hijo no puede exceder 10 caracteres"),
    tiposeguro: yup.string().nullable().optional(),
    nombrecompania: yup.string().required("La compañía de seguros es requerido"),
    tasa: yup
        .number()
        .typeError("La tasa debe ser un número")
        .required("La tasa es requerida")
        .min(0, "La tasa no puede ser negativa")
        .max(5, "La tasa no puede exceder 5 caracteres"),
    fechainiciovigencia: yup
        .date()
        .required("La fecha de inicio de vigencia es requerida"),
    fechaterminovigencia: yup
        .date()
        .typeError("La fecha de término de vigencia es requerida")
        .required("La fecha de término de vigencia es requerida")
        .min(
            yup.ref("fechainiciovigencia"),
            "La fecha de término no puede ser menor que la fecha de inicio"
        ),
    diapago: yup
        .number()
        .required("El día de pago es requerido"),
    monedapagoCodigo: yup.string().required("La moneda de pago es requerida"),
    descripcion: yup.string().notRequired().optional(),
    valorprima: yup.number().notRequired().min(0, "El valor de la prima no puede ser negativo")
        .max(9, "El valor de la prima no puede exceder 9 caracteres"),
});

const CreateEditPoliza: React.FC<CreateEditPolizaProps> = ({ codigoPoliza, onVolver, polizaEditar, onHide, isEdit, refresh }) => {
    const [optionsDiaCobro, setOptionsDiaCobro] = useState<selectorTransversal[]>([]);
    const [optionsTipoSeguro, setOptionsTipoSeguro] = useState<selectorTransversal[]>([]);
    const [showCobertura, setShowCobertura] = useState(false);
    const [coberturas, setCoberturas] = useState<CoberturaPoliza[]>([]);
    const [coberturaEditar, setCoberturaEditar] = useState<CoberturaPoliza | undefined>();
    const [isEditarCobertura, setIsEditarCobertura] = useState(false);
    const [compania, setCompania] = useState<selectorTransversal[]>([]);
    const [monedas, setMonedas] = useState<selectorTransversal[]>([]);

    const save = usePoliza();
    const { addToast } = useToast();


    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
        watch,
    } = useForm<PolizaSeguro>({
        mode: 'onBlur',
        resolver: yupResolver(schema),

    })

    const dataForm = watch();

    const refreshCoberturas = async () => {
        if (dataForm.codigo) {
            const data = await getCoberturas(dataForm.codigo);
            setCoberturas(data);
        }
    };
    const handleOpenModalCobertura = () => {
        setShowCobertura(true);
    };
    const { COLUMNS } = useColumnsCobranza({
        controlTabla: null,
        setCoberturaEditar,
        setIsEditarCobertura,
        onCreateEditClick: handleOpenModalCobertura,
        refresh: refreshCoberturas
    });



    useEffect(() => {
        const cargarDatos = async () => {
            if (polizaEditar && isEdit) {
                const resp = await getDetallePoliza(codigoPoliza ?? "");
                if (resp.status === StatusCode.Ok) {
                    const data = resp.data;

                    setValue("codigo", data.codigo);
                    setValue("codigohijo", data.codigohijo);
                    setValue("tiposeguro", data.tiposeguro);
                    setValue("nombrecompania", data.nombrecompania);
                    setValue("tasa", data.tasa);
                    setValue("fechainiciovigencia", data.fechainiciovigencia);
                    setValue("fechaterminovigencia", data.fechaterminovigencia);
                    setValue("diapago", data.diapago);
                    setValue("monedapagoCodigo", data.monedapagoCodigo);
                    setValue("descripcion", data.descripcion);
                    setValue("valorprima", data.valorprima);

                }
            } else {
                setValue("valorprima", 0);
            }
        };
        cargarDatos();

    }, [polizaEditar, codigoPoliza, setValue, reset]);

    useEffect(() => {
        async function fetchData() {
            const data = await getCoberturas(codigoPoliza);
            setCoberturas(data);

        }
        if (codigoPoliza) fetchData();
    }, [codigoPoliza]);


    const tipoDiaCobro = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.DIA_COBRO)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsDiaCobro(data)
        }
        return;
    }

    const tipoSeguro = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_SEGURO)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsTipoSeguro(data)
        }
        return;
    }
    const consultarCompania = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getCompanias();
        if (resp.status !== StatusCode.Ok)
            return;

        setCompania(resp.data.items);
    }

    const consultarMonedas = async () => {
        const resp: AxiosResponse<ListResponseDto<monedaOrigenDto>> = await getMonedas();
        if (resp.status === StatusCode.Ok) {
            const data: monedaOrigenDto[] = await resp.data.items;
            const options = data.map((m: monedaOrigenDto) => ({
                label: m.descripcion,
                value: m.codigo,
            }));
            setMonedas(options);
        }
        return;
    }

    useEffect(() => {
        const inicializar = async () => {
            await tipoDiaCobro();
            await tipoSeguro();
            await consultarCompania();
            await consultarMonedas();
        };

        inicializar();
    }, []);

    const handleCreateEditButtonClick = async () => {
        await handleSubmit(onSubmit)();
    }
    const [disabledButton, setDisabledButton] = useState<boolean>(true);
    const onSubmit = async (data: PolizaSeguro) => {
        const response = await save(data, polizaEditar);
        if (response.status === StatusCode.NoContent) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: polizaEditar ?
                    'Poliza modificada con exito.'
                    : 'Poliza creada con exito.',
            });
            setDisabledButton(false);
            if (refresh) refresh();

        }
    }

    const handleCloseModalCobertura = () => {
        setShowCobertura(false);
        setCoberturaEditar(undefined);
        setIsEditarCobertura(false);
    };

    const handleCoberturaButtonClick = () => {
        setCoberturaEditar(undefined);
        setIsEditarCobertura(false);
        setShowCobertura(true);
    }
    return (
        <>
            <Card sx={{ mb: 2, backgroundcolor: 'white', p: 2 }} raised>
                <Grid2 container alignItems="center" spacing={2} >

                    <Grid2 size={2}>
                        <Typography className='card-title' variant="h6"> {polizaEditar ? 'Editar póliza' : 'Crear póliza'}
                        </Typography>
                    </Grid2>

                    <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                        <MButton
                            variant="contained"
                            onClick={handleCreateEditButtonClick}
                        >
                            Guardar
                        </MButton>
                        <MButton variant="contained" color="inherit" onClick={onVolver}>
                            Cancelar
                        </MButton>

                    </Grid2>

                </Grid2>
                <Grid2 container spacing={2} sx={{ mt: 2 }} >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={3}>
                                <InputText
                                    name="codigo"
                                    control={control}
                                    label='Código'
                                    desabilitado={isEdit || !disabledButton}
                                    error={errors.codigo}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputText
                                    name="codigohijo"
                                    control={control}
                                    label='Código hijo'
                                    desabilitado={isEdit || !disabledButton}
                                    error={errors.codigohijo}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputSelect
                                    name="tiposeguro"
                                    control={control}
                                    label="Tipo seguro"
                                    options={optionsTipoSeguro}
                                    disabled={isEdit || !disabledButton}
                                    error={errors.tiposeguro}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputSelect
                                    name="nombrecompania"
                                    control={control}
                                    label="Compañia seguros"
                                    options={compania}
                                    error={errors.nombrecompania}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputNumber
                                    name="tasa"
                                    control={control}
                                    label="Tasa"
                                    decimales={4}
                                    disabled={isEdit || !disabledButton}
                                    error={errors.tasa}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputFecha
                                    name="fechainiciovigencia"
                                    control={control}
                                    label="Fecha inicio vigencia"
                                    fecha={dataForm.fechainiciovigencia}
                                    error={errors.fechainiciovigencia}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputFecha
                                    name="fechaterminovigencia"
                                    control={control}
                                    label="Fecha término vigencia"
                                    fecha={dataForm.fechaterminovigencia}
                                    error={errors.fechaterminovigencia}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputSelect
                                    name="diapago"
                                    control={control}
                                    label="Dia pago"
                                    options={optionsDiaCobro}
                                    error={errors.diapago}

                                />
                            </Grid2>

                            <Grid2 size={3}>
                                <InputSelect
                                    name="monedapagoCodigo"
                                    control={control}
                                    label="Moneda remesa"
                                    options={monedas}
                                    error={errors.monedapagoCodigo}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputText
                                    name="descripcion"
                                    control={control}
                                    label="Descripción"
                                    error={errors.descripcion}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <InputNumber
                                    name="valorprima"
                                    control={control}
                                    label="Monto prima dividendo"
                                    decimales={4}
                                    disabled={dataForm.tiposeguro !== "OTROS"}
                                    error={errors.valorprima}
                                />
                            </Grid2>
                        </Grid2>
                        <Grid2 container spacing={1} marginTop={2} justifyContent={"flex-end"}>


                        </Grid2>
                    </form>
                </Grid2>
            </Card>

            <Card sx={{ mb: 2, backgroundcolor: 'white', p: 2 }} raised>
                <Grid2 container alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Typography className="card-title" variant="h6">Coberturas</Typography>
                    <MButton
                        variant="contained"
                        onClick={handleCoberturaButtonClick}
                        disabled={!isEdit && disabledButton}
                    >
                        Nueva cobertura
                    </MButton>
                </Grid2>
                <Tabla
                    titulo=""
                    columns={COLUMNS}
                    data={coberturas}
                    showFooter
                />
            </Card>

            <ModalCobertura
                show={showCobertura}
                codigo={dataForm.codigo ?? ""}
                codigohijo={dataForm.codigohijo ?? ""}
                onHide={handleCloseModalCobertura}
                refresh={refreshCoberturas}
                isEditar={isEditarCobertura}
                coberturaEditar={coberturaEditar}
            />
        </>

    );
}
export default CreateEditPoliza;


